import { Component, forwardRef } from '@angular/core';
import {
  ControlValueAccessor,
  FormControl,
  NG_VALUE_ACCESSOR,
} from '@angular/forms';

@Component({
  selector: 'app-radio-group-range-type',
  templateUrl: './radio-group-range-type.component.html',
  styleUrls: ['./radio-group-range-type.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => RadioGroupRangeTypeComponent),
      multi: true,
    },
  ],
})
export class RadioGroupRangeTypeComponent implements ControlValueAccessor {
  dataValues = [
    {
      label: '12 months',
      value: '12-months',
    },
    {
      label: '30 days',
      value: '30-days',
    },
    {
      label: '7 days',
      value: '7-days',
    },
    {
      label: '24 hours',
      value: '24-hours',
    },
  ];

  public formControl: FormControl = new FormControl();

  constructor() {}

  writeValue(value: any): void {
    this.formControl.patchValue(value);
  }

  registerOnChange(fn: any): void {
    this.formControl.valueChanges.subscribe((val) => fn(val));
  }

  registerOnTouched(fn: any): void {
    this.formControl.valueChanges.subscribe((val) => fn(val));
  }
}
